import { render, staticRenderFns } from "./Transfert.vue?vue&type=template&id=58ed3690"
import script from "./Transfert.vue?vue&type=script&lang=js"
export * from "./Transfert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports